import { Navigate, useParams } from "react-router-dom";

/**
 * Older emails used /applications/:id. Canonical app detail is /visa-application?applicationId=&visaType=
 * Omit visaType here — VisaApplication resolves it after load (keeps legacy links short).
 */
const ApplicationDeepLinkRedirect = () => {
  const { applicationId } = useParams();
  const id = applicationId != null ? String(applicationId).trim() : "";
  if (!id) {
    return <Navigate to="/visa-application" replace />;
  }
  return (
    <Navigate
      to={`/visa-application?applicationId=${encodeURIComponent(id)}`}
      replace
    />
  );
};

export default ApplicationDeepLinkRedirect;
